import { branchAction } from "../actionTypes";
import { Url } from "../../config/config";
import axios from "axios";
import { isLoggedIn } from "../../utils";
//==================================//

export const getBranchListInitiate = () => ({
  type: branchAction.BRANCH_LIST_INITIATE,
});

export const getBranchListSuccess = (data) => ({
  type: branchAction.BRANCH_LIST_SUCCESS,
  payload: data,
});

export const getBranchListFailure = (data) => ({
  type: branchAction.BRANCH_LIST_FAILURE,
  payload: data,
});

export function getBranchList(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(getBranchListInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/branchList`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data.status === 200) {
            dispatch(getBranchListSuccess(data));
          } else {
            dispatch(getBranchListFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(getBranchListFailure(err));
          reject(err);
        }),
    );
  };
}

//=======================add--branch=============

export const addBranchInitiate = () => ({
  type: branchAction.ADD_BRANCH_INITIATE,
});

export const addBranchSuccess = (data) => ({
  type: branchAction.ADD_BRANCH_SUCCESS,
  payload: data,
});

export const addBranchFailure = (data) => ({
  type: branchAction.ADD_BRANCH_FAILURE,
  payload: data,
});

export function addBranch(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(addBranchInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/addBranch`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data.status === 200) {
            dispatch(addBranchSuccess(data));
          } else {
            dispatch(addBranchFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(addBranchFailure(err));
          reject(err);
        }),
    );
  };
}

//==============edit-branch=======================
export const editBranchInitiate = () => ({
  type: branchAction.BRANCH_EDIT_INITIATE,
});

export const editBranchSuccess = (data) => ({
  type: branchAction.BRANCH_EDIT_SUCCESS,
  payload: data,
});

export const editBranchFailure = (data) => ({
  type: branchAction.BRANCH_EDIT_FAILURE,
  payload: data,
});

export function editBranch(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(editBranchInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/updateBranch`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data.status === 200) {
            dispatch(editBranchSuccess(data));
          } else {
            dispatch(editBranchFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(editBranchFailure(err));
          reject(err);
        }),
    );
  };
}

//==================branchDetails==============//
export const branchDetailsInitiate = () => ({
  type: branchAction.BRANCH_DETAILS_INITIATE,
});

export const branchDetailsSuccess = (data) => ({
  type: branchAction.BRANCH_DETAILS_SUCCESS,
  payload: data,
});

export const branchDetailsFailure = (data) => ({
  type: branchAction.BRANCH_DETAILS_FAILURE,
  payload: data,
});

export function branchDetails(payload) {
  return (dispatch) => {
    const token = isLoggedIn("ownerLogin");
    dispatch(branchDetailsInitiate(payload));
    return new Promise((resolve, reject) =>
      axios
        .post(`${Url}store/branchDetails`, payload, {
          headers: { Authorization: `${token}` },
        })
        .then((response) => {
          const data = response.data;
          if (data.status === 200) {
            dispatch(branchDetailsSuccess(data));
          } else {
            dispatch(branchDetailsFailure(data));
          }
          resolve(data);
        })
        .catch((err) => {
          dispatch(branchDetailsFailure(err));
          reject(err);
        }),
    );
  };
}
